export * from './getData';
